import { Box, Flex, Text, Input, Button } from "@chakra-ui/react";
import Countdown from "@/components/countdonw";
import { useState, useEffect } from "react";
import { throttle } from "lodash";
import { postGetPhoneCodeApi, postVerifyPhoneCodeApi } from "@/api/common";
import { useAppSelector } from "@/state/hooks";
import { useI18n } from "@/hooks/useI18n";
import { geetestFlow } from "@/pages/resetAccountInfo/api";
import { BXButton } from "@/styles";

const Phone = ({ onClose, requestId, onOk }) => {
  const { t } = useI18n();
  const [reSend, setReSend] = useState(false);
  const codeRule = /^\d{6}$/;
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(false);
  const [codeText, setCodeText] = useState("");

  const { email, phone_code, phone_number } = useAppSelector(
    (state) => state.user.userInfo
  );
  const handleTimeout = () => {
    //时间到
    setReSend(true);
  };

  const sendMsgFunc = throttle(async () => {
    setReSend(true);
    const geetestFlowParams = {
      phone_code: phone_code || "",
      phone_number: phone_number || "",
      email: email || "",
      request_id: requestId,
    };
    geetestFlow(geetestFlowParams, async () => {
      const sendMsg = await postGetPhoneCodeApi({
        request_id: requestId,
        phone_code: phone_code || "",
        phone_number: phone_number || "",
        email: email || "",
      });
      if (sendMsg.code === 0) {
        setReSend(false);
      } else {
        setReSend(true);
      }
    });
  }, 5000);
  const checkCode = throttle(async () => {
    if (code) {
      const res = await postVerifyPhoneCodeApi({
        request_id: requestId,
        code: code,
      });
      if (res.code === 0) {
        onOk();
      }
    } else {
      setCodeError(true);
    }
  }, 5000);

  const codeChange = (e) => {
    const codeVal = e.target.value;
    if (codeVal) {
      setCodeError(false);

      if (codeRule.test(codeVal)) {
        setCode(codeVal);
        setCodeError(false);
      } else {
        setCodeText(t("yCCsuXAjuRzOLNxo"));
        setCodeError(true);
      }
    } else {
      setCodeText(t("LuigfaXzmPRCftdFOV"));
      setCodeError(true);
    }
  };

  useEffect(() => {
    sendMsgFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Flex
      justifyContent={"center"}
      w={"90%"}
      flexDirection={"column"}
      margin={"0 auto"}
    >
      <Box>
        <Text fontSize="25px" fontWeight={"600"} color="t.100">
          {t("OivHVusJobtDPuGMSbDN")}
        </Text>
        <Text
          fontSize="16px"
          fontWeight={"500"}
          color="t.100"
          mt="20px"
          mb="20px"
        >
          {t("MvJmrHwTdesvsHWH")}
        </Text>
        <Text fontSize="16px" color="t.100">
          {t("OXrwZMwkWAjoSDDALzow")}
        </Text>
        <Flex mt="5px">
          <Input
            h="44px"
            borderRadius={"12px"}
            placeholder={t("cTlSqXgGENkCAQQJCHx")}
            fontSize="12px"
            isInvalid={codeError}
            bg={codeError ? "red.50" : "none"}
            errorBorderColor="red.100"
            _placeholder={{ color: "t.50" }}
            onBlur={codeChange}
          />
          {reSend ? (
            <Button
              ml="10px"
              fontSize="14px"
              padding="0 30px"
              bg="blue.100"
              color="#fff"
              fontWeight={"400"}
              borderRadius={"30px"}
              _hover={{ bg: "blue.80" }}
              h="44px"
              cursor={"pointer"}
              onClick={sendMsgFunc}
            >
              {t("fxHeYqwgtTcKAdCKPyVe")}
            </Button>
          ) : (
            <Button
              ml="10px"
              fontSize="14px"
              padding="0 30px"
              bg="t.50"
              color="#fff"
              fontWeight={"400"}
              borderRadius={"30px"}
              _hover={{ bg: "t.50" }}
              disabled="true"
              h="44px"
              cursor={"not-allowed"}
            >
              {t("fxHeYqwgtTcKAdCKPyVe")}(
              {<Countdown onTimeout={handleTimeout} secondsInit="60" />})
            </Button>
          )}
        </Flex>
        {codeError && (
          <Text color="red.100" fontSize="12px" mt="5px">
            {codeText}
          </Text>
        )}
        <Box mt={"20px"}>
          <Flex justifyContent={"space-between"} mt={"30px"} w={"100%"}>
            <BXButton
              flex={"1"}
              className="cancel"
              onClick={() => {
                onClose();
              }}
            >
              {t("UNForxvjDLCZdGrmWkX")}
            </BXButton>
            <BXButton
              ml={"10px"}
              flex={"2.5"}
              onClick={() => {
                checkCode();
              }}
            >
              {t("tOaRBVUJHpnSgDBrGON")}
            </BXButton>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default Phone;
